import React, { useState, useCallback } from 'react';
import './ArchiveList.scss';
import { Pagination, Tag, Spin } from 'antd';
import { getShipmentsHistoryList } from '../../../services/shipments';
import { useFetch } from '../../../utils/hooks';
import { useLocation } from 'react-router-dom';
import ShipmentDetails from '../../ShipmentDetails/ShipmentDetails';
import CollapseList from '../../CollapseList/CollapseList';
import ArchiveListTable from './ArchiveListTable/ArchiveListTable';

const PER_PAGE = 25;

const ArchiveList = ({ bookingList, filterList }) => {
  const [page, setPage] = useState(1);
  const [selectedShipment, setSelectedShipment] = useState(null);
  const [shipmentOptionsOpened, setShipmentOptionsOpened] = useState(null);
  const { pathname, search } = useLocation();

  const origin = pathname?.split('/').filter(s => s !== '')[0];
  // Extract "as" parameter from URL
  const searchParams = new URLSearchParams(search);
  const asParam = searchParams.get('as'); // This will extract the "as" parameter
  const { data, loading, refetch } = useFetch(useCallback(() => {
    return getShipmentsHistoryList({ bookingList, filterList, as: asParam }, page);
  }, [page, bookingList, filterList]));

  const shipments = data?.shipments;
  const totalPages = data?.total;

  function clearSelectedShipment() {
    window.history.replaceState('', '', `/${origin}`);
    setShipmentOptionsOpened(null);
    setSelectedShipment(null);
  }

  function selectShipment(shipment) {
    shipment.state && shipment.pol?.code && setSelectedShipment(shipment);
    window.history.pushState('', '', `/${origin}/explore#${shipment.url}`);
  }

  const tagSummary = (tags, expand = false) => {
    if (expand) {
      return <>
        {tags[0] && (<Tag className="tag" color="#DADCE0">{tags[0]}</Tag>)}
        {tags[1] && (<Tag className="tag" color="#DADCE0">{tags[1]}</Tag>)}
        {tags[2] && (<Tag className="tag" color="#DADCE0">+{tags.length - 2}</Tag>)}
      </>;
    }
    return (<Tag className="tag" color="#DADCE0">+{tags.length}</Tag>);
  };

  if (loading) {
    return <Spin className="spinner" size="large" />;
  }

  return (
    <div className="ArchiveList">
      <div className="header">
        My Shipments History List
      </div>
      <div className="elements">
        <div className="elements-table">
          <ArchiveListTable shipments={shipments} selectShipment={selectShipment} refetch={refetch}
                            tagSummary={tagSummary} readableOnly={true} />
        </div>

        <div className="elements-card">
          <CollapseList shipments={shipments} selectShipment={selectShipment} refetch={refetch}
                        tagSummary={tagSummary} readableOnly={true} />
        </div>
        {
          totalPages > PER_PAGE &&
          <div className="pagination">
            <Pagination defaultCurrent={page} total={totalPages} defaultPageSize={25} pageSize={25}
                        showSizeChanger={false} onChange={(page) => setPage(page)} />
          </div>
        }
      </div>
      {selectedShipment &&
        <ShipmentDetails shipment={selectedShipment} clearSelectedShipment={clearSelectedShipment}
                         readableOnly={true} refetch={refetch} />}
    </div>
  );
};

export default ArchiveList;
